import axios from 'axios'
import {Message} from 'element-ui'
import router from '../router'
import state from '../store/state'
axios.interceptors.request.use(config=> {

    if (config.url.indexOf("login") == -1 && config.method=="get") {
      config.url = (config.url.indexOf('?') == '-1') ?
        config.url + "?hrId=" + state.user.id :
        config.url + "&hrId=" + state.user.id;
    }
    return config;
}, err=> {
  Message.error({message: '请求超时!'});
  return Promise.resolve(err);
});

axios.interceptors.response.use(data=> {
  if (data.status && data.status == 200 && data.data.status == 'error') {
    Message.error({message: data.data.msg});
    return;
  }
  return data;
}, err=> {
  if (err.response.data.message=='Token验证失败，请重新登录！'){
    Message.error({message: err.response.data.message});
    window.localStorage.clear();
    setTimeout( top.location.href='/',5000);
  }else if(err.message == 'Network Error'){

      Message.error({message: '超时未操作,请重新登录!'});
      setTimeout( top.location.href='/',5000);
  }else if (err.response.status == 504||err.response.status == 404) {

    Message.error({message: '服务器被吃了⊙﹏⊙∥,重新登录试试吧...'});
    setTimeout(top.location.href='/',5000);
  } else if (err.response.status == 403) {
    Message.error({message: '权限不足,请联系管理员!'});
  } else if (err.response.status == 302) {
    Message.error({message: '超时未操作,请重新登录!'});
   setTimeout(top.location.href='/',5000);
  }else if (err.response.status == 401) {
      Message.error({message: '未授权的操作,请重新登录!'});
      setTimeout( top.location.href='/',5000);
  }else {
    Message.error({message: '未知错误!'});
  }
  return Promise.resolve(err);
})

let base = '';
export const postJsonRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    transformRequest: [],
    headers: {
      'Content-Type': 'application/json',
      'token': state.user.remark,
      'appUserId': state.user.id
    }
  });
}
export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'token': state.user.remark,
      'appUserId': state.user.id
    }
  });
}
export const uploadFileRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data',
      'token': state.user.remark,
      'appUserId': state.user.id
    }
  });
}
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'token': state.user.remark,
      'appUserId': state.user.id
    }
  });
}
export const deleteRequest = (url) => {
  return axios({
    method: 'delete',
    url: `${base}${url}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'token': state.user.remark,
      'appUserId': state.user.id
    }
  });
}
export const getRequest = (url) => {
  return axios({
    method: 'get',
    url: `${base}${url}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'token': state.user.remark,
      'appUserId': state.user.id
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/api.js